"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class UserController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/user',
            edit: '/v1/user/:objectId',
            delete: '/v1/user/:objectId/force?organisation=:parentId',
            forceDelete: '/v1/user/:userId/force',
            setPassword: '/v1/user/:userId/password/set',
            changePassword: '/v1/user/:userId/password/change',
            getAPIKey: '/v1/user/:userId/key',
            renewAPIKey: '/v1/user/:userId/key/renew',
            revokeAPIKey: '/v1/user/:userId/key',
            unBlock: '/v1/user/:userId/reset',
            current: 'v1/user/current',
            setOrganisations: '/v1/user/:userId/organisations',
        };
    }
    changePassword(currentPassword, password, userId) {
        return this.manager.post({ url: this.endpoints.changePassword, params: { userId } }, { currentPassword, password });
    }
    setPassword(password, userId) {
        return this.manager.post({ url: this.endpoints.setPassword, params: { userId } }, { password });
    }
    getAPIKey(userId) {
        return this.manager.get({ url: this.endpoints.getAPIKey, params: { userId } });
    }
    renewAPIKey(userId) {
        return this.manager.post({ url: this.endpoints.renewAPIKey, params: { userId } });
    }
    revokeAPIKey(userId) {
        return this.manager.delete({ url: this.endpoints.revokeAPIKey, params: { userId } });
    }
    unBlock(userId) {
        return this.manager.post({ url: this.endpoints.unBlock, params: { userId } });
    }
    getCurrent(organisation) {
        // ! CHECK if this still works
        return this.manager.get({ url: this.endpoints.current }, organisation && {
            headers: {
                'x-organisation': organisation,
            },
        });
    }
    switchOrganisation(organisation) {
        return this.manager.get({ url: this.endpoints.current }, {
            headers: {
                'X-Organisation': organisation,
            },
        });
    }
    setOrganisations(organisations, userId) {
        return this.manager.put({
            url: this.endpoints.setOrganisations,
            params: { userId },
        }, {
            organisations,
        });
    }
    forceDelete(userId) {
        return this.manager.delete({
            url: this.endpoints.forceDelete,
            params: {
                userId,
            },
        });
    }
}
exports.default = UserController;
